import React, { useState, useEffect } from "react";

// Full-screen rotating background: Beas satsang ghar photos with slow
// Ken Burns (zoom/pan) motion + crossfade, under a dark red-tinted overlay
// so the red/white/black UI stays readable on top.
const IMAGES = [
  "https://images.unsplash.com/photo-1686896991823-661d1fd1bc00?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNTl8MHwxfHNlYXJjaHwzfHxSYWRoYSUyMFNvYW1pJTIwU2F0c2FuZyUyMEJlYXMlMjBkZXJhfGVufDB8fHx8MTc5MTA5NTMyM3ww&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1739521610393-97c8de9be2d1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNTl8MHwxfHNlYXJjaHwyfHxSYWRoYSUyMFNvYW1pJTIwU2F0c2FuZyUyMEJlYXMlMjBkZXJhfGVufDB8fHx8MTc5MTA5NTMyM3ww&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1661470468460-5733b5e74ba4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNTl8MHwxfHNlYXJjaHwxfHxSYWRoYSUyMFNvYW1pJTIwU2F0c2FuZyUyMEJlYXMlMjBkZXJhfGVufDB8fHx8MTc5MTA5NTMyM3ww&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1711883157886-ffb4f8210835?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNTl8MHwxfHNlYXJjaHw0fHxSYWRoYSUyMFNvYW1pJTIwU2F0c2FuZyUyMEJlYXMlMjBkZXJhfGVufDB8fHx8MTc5MTA5NTMyM3ww&ixlib=rb-4.1.0&q=85",
];

const ROTATE_MS = 8000;

export const BackgroundSlideshow = () => {
  const [idx, setIdx] = useState(0);
  useEffect(() => {
    const t = setInterval(() => setIdx((i) => (i + 1) % IMAGES.length), ROTATE_MS);
    return () => clearInterval(t);
  }, []);
  return (
    <div className="fixed inset-0 z-0 overflow-hidden bg-[#efe3c9]" aria-hidden="true" data-testid="bg-slideshow">
      {IMAGES.map((src, i) => (
        <div
          key={src}
          className="absolute inset-0 bg-cover bg-center transition-opacity duration-[2500ms] ease-in-out"
          style={{
            backgroundImage: `url(${src})`,
            opacity: i === idx ? 1 : 0,
            animation: i === idx ? "kenburns 9s ease-out forwards" : "none",
          }}
        />
      ))}
      {/* readability overlays — warm cream veil so the page reads light & official */}
      <div className="absolute inset-0 bg-[#f3ead6]/80" />
      <div className="absolute inset-0 bg-gradient-to-b from-[#5e1414]/15 via-[#f3ead6]/70 to-[#efe3c9]/90" />
    </div>
  );
};
